import { ApiError, ApiParameter } from "@insite/client-framework/Services/ApiService";

export interface pdfResultModel {
    result: any;
}

export interface DownloadPdfParameter extends ApiParameter {
    invoiceNumber?: string;
}

export const url = "/api/v2/report/invoice/";

export async function getGetPdf(parameter: DownloadPdfParameter) {
    const response = await fetch(`${url}${parameter.invoiceNumber}`);

    try {
        const blob = response.ok && (await response.blob());
        if (!response.ok) {
            throw new Error(
                JSON.stringify({
                    status: response.status,
                    errorJson: {
                        message: response.statusText,
                    },
                }),
            );
        }
        return blob;
    } catch (error) {
        let message: string;
        let errorJson: any;
        if (response.headers.get("Content-Type")?.startsWith("application/json")) {
            errorJson = (await response.json()) as { message: string; exceptionMessage?: string };
            message = errorJson.exceptionMessage ?? errorJson.message;
        } else {
            message = await response.text();
        }
        throw new ApiError(`${url}${parameter.invoiceNumber}`, response, message, errorJson);
    }
}
